import { useSwitchOrganization, useUser } from '@tbitop/authentication';
import { useNutzerMandant, useNutzerMandanten, usePartnerWechselnMutation } from '@tbitop/oneplatform-api';
export type { Mandant } from './model';

export const useMandanten = () => {
  const { mandanten } = useNutzerMandanten();
  const user = useUser();
  const currentMandant = useNutzerMandant();
  const switchOrganization = useSwitchOrganization();
  const { execute: partnerWechseln } = usePartnerWechselnMutation();

  async function switchOrganizationAndResetPartner(organizationId: string) {
    if (user?.selectedPartner) {
      // Partner zurücksetzen, wenn die wirkliche Organisation gewechselt wird
      await partnerWechseln({ mandantenId: '' });
    }
    await switchOrganization(organizationId);
  }

  return { mandanten, currentMandant, switchOrganization: switchOrganizationAndResetPartner };
};
